import { Routes, Route } from 'react-router-dom';
import { TerminalPage } from './presentation/pages';
import './styles/index.css';

function App() {
    return (
        <Routes>
            <Route path="/:cnpj" element={<TerminalPage />} />
            <Route path="/" element={<TerminalPage />} />
        </Routes>
    );
}

export default App;

